export default class Unit {
  private readonly unitValue;

  constructor(unitValue: any) {
    this.unitValue = unitValue;
  }

  static fromUnitless(value: any): Unit {
    return new Unit(value);
  }

  format() {
    return this.getValue();
  }

  unit(): string {
    return '';
  }

  getValue() {
    return this.unitValue;
  }

  gt(number: number): boolean {
    return this.getValue() > number;
  }

  toString(): string {
    return `${this.getValue()}`;
  }
}
